<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-icon
      name="chevron-back-outline"
      slot="start"
      (click)="return()"
    ></ion-icon>
    <ion-label data-cy="check-reference-label">
      {{ 'i18n.payments.addBankAccountModal.checkReference.title' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <app-check-reference-popover
    data-cy="check-reference-img"
    [imageDetail]="imageDetail"
    [isTouch]="true"
  ></app-check-reference-popover>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="got-it-modal-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="return()"
      >
        {{
          'i18n.payments.addBankAccountModal.checkReference.gotIt' | translate
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
